// extracted by mini-css-extract-plugin
export var container = "_t4-0";
export var table = "_t4-2";
export var tableWrapper = "_t4-1";